import { render, staticRenderFns } from "./SwitchTableButtons.vue?vue&type=template&id=500e3fe9&scoped=true&"
import script from "./SwitchTableButtons.vue?vue&type=script&lang=js&"
export * from "./SwitchTableButtons.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTableButtons.vue?vue&type=style&index=0&id=500e3fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e3fe9",
  null
  
)

export default component.exports